"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./Table.scss");
var Table = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, dusk = _a.dusk;
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: "table-container" },
        react_1.default.createElement("table", { "data-dusk": dusk + "-table", className: "table " + className }, children)));
};
exports.default = Table;
//# sourceMappingURL=Table.js.map